(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["making-product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-back]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!document.referrer || history.state?.cartDrawerOpen) return;

    let referrer;
    try {
      referrer = new URL(document.referrer);
    } catch {
      return;
    }

    const collectionPath = new URL(link.href).pathname.replace(/\/$/, '');
    const cameFromCollection =
      referrer.origin === window.location.origin &&
      (referrer.pathname === collectionPath || referrer.pathname.startsWith(`${collectionPath}/`));
    if (!cameFromCollection) return;

    event.preventDefault();
    history.back();
  });

  function revealCurrentSpecimen() {
    document.querySelectorAll('.making-product__rail-list').forEach((list) => {
      const current = list.querySelector('[aria-current="page"]');
      if (!current || list.scrollWidth <= list.clientWidth) return;
      list.scrollLeft += current.getBoundingClientRect().left - list.getBoundingClientRect().left;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealCurrentSpecimen);
  else revealCurrentSpecimen();

  } catch(e) { console.error(e); }
})();
})();
